import React from "react";

const faqs = [
  {
    question: "What is Screenify?",
    answer:
      "Screenify is an AI-powered recruitment platform for resume screening, candidate evaluation, document verification, and structured onboarding workflows.",
  },
  {
    question: "How does AI resume parsing work?",
    answer:
      "The AI extracts skills, experience, education, and contact details from resumes instantly.",
  },
  {
    question: "Is there a free trial available?",
    answer: "Yes, you can start with a free trial to test all major features.",
  },
  {
    question: "Can I upload resumes in bulk?",
    answer: "Yes, Screenify supports bulk resume upload for faster screening.",
  },
  {
    question: "Can I export the screened data to Excel?",
    answer:
      "Yes. You can export candidate data, scores, and screening reports directly to Excel for easy sharing and analysis.",
  },
  {
    question: "Is candidate data secure?",
    answer:
      "Yes, we follow strong security practices and strict privacy policies.",
  },
  {
    question: "What does your Document verification include?",
    answer:
      "Our Document verification includes Employment Verification, Education Verification, Criminal Record Checks, and Identity Validation.",
  },
  {
    question: "Does the system provide human-like reasoning after screening?",
    answer:
      "Yes. After screening, the system generates a detailed human-like explanation for why the candidate is validated as Yes or No. Example: The candidate has relevant experience in Python, expertise in Django and related frameworks, meets all mandatory skills, and has an education background aligned with the role.",
  },
];

const FaqSection = () => {
  return (
    <section className="py-5 bg-light">
      <div className="container">
        <h2 className="text-center mb-4 fw-bold">Frequently Asked Questions</h2>

        <div className="accordion" id="faqAccordion">
          {faqs.map((faq, index) => (
            <div className="accordion-item" key={index}>
              <h2 className="accordion-header">
                <button
                  className={`accordion-button ${
                    index !== 0 ? "collapsed" : ""
                  }`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#faq${index}`}
                >
                  {faq.question}
                </button>
              </h2>
              <div
                id={`faq${index}`}
                className={`accordion-collapse collapse ${
                  index === 0 ? "show" : ""
                }`}
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
